import React, { FC, ReactElement, useEffect, useRef } from 'react';
import { ModalTypes } from '../../../constans/modal.constants';
import { createPortal } from 'react-dom';
import ModalHeader from './modal-components/modal-header';
import ModalBody from './modal-components/modal-body';
import ModalFooter from './modal-components/modal-footer';
import { BackDrop } from '../..';
import './modal.scss';

export type TElement = ReactElement | JSX.Element[] | JSX.Element;
export interface IModalWrapperProps extends IModalCommonProps, Partial<IModalHeaderProps>, Partial<IModalBodyProps>, Partial<IModalFooterProps> {
  additionalClassNames?: string;
  children?: TElement;
  hideBackdrop?: boolean;
  customBackdropClassNames?: string;
}

export interface IModalHeaderProps {
  headerText: string;
  customHeader: TElement;
  closeIcon: string;
}

export interface IModalBodyProps {
  bodyText: string;
  customBody: TElement;
  htmlString: string;
  contentAlign: string;
}

export interface IModalFooterProps {
  footerText: string;
  customFooter: TElement;
  doneButtonText: string;
  cancelButtonText: string;
}

export interface IModalCommonProps {
  cancelAction: () => void;
  modalType: ModalTypes;
  doneAction?: () => void;
}

const ModalComponentsWrapper: FC<IModalWrapperProps> = (props: IModalWrapperProps) => {
  const modalRoot = document.getElementById('modal-root') as HTMLElement;
  const el = useRef(document.createElement('div'));

  const removeModalHandler = (current: HTMLDivElement): void => {
    modalRoot.removeChild(current);
  };

  const appendModalHandler = (current: HTMLDivElement): void => {
    modalRoot.appendChild(current);
  };

  useEffect(() => {
    const current = el.current;
    appendModalHandler(current);
    return () => removeModalHandler(current);
  }, []);

  const ModalWrapper = () => (
    <>
      <div className={`modal-container ${props.additionalClassNames || ''}`}>
        <div className='modal' id='modal' aria-hidden='true'>
          <div className='modal-dialog'>
            {props.children
              ? <>{props.children} </>
              : <>
                <ModalHeader {...props}/>
                <ModalBody {...props}/>
                <ModalFooter {...props}/>
              </>
            }
          </div>
        </div>
      </div>
      <BackDrop isVisible isBlack/>
    </>
  );

  return createPortal(<ModalWrapper/>, el.current);

};

export default ModalComponentsWrapper;
